export { default as SquareSeparateSolidIcon } from './SquareSeparateSolidIcon';
